import {
  AppData,
  CalcMode,
  Calculator,
} from "../../interface/functionalityInterface";
import { Capacitance } from "../baseQuantities/capacitance";
import { ElectricCharge } from "../baseQuantities/electricCharge";
import { Energy } from "../baseQuantities/energy";
import { Voltage } from "../baseQuantities/voltage";

const capacitanceMode: CalcMode = {
  id: "001capacitance",
  name: "capacitance",
  baseQuantities: [{ ...Capacitance }, { ...ElectricCharge }, { ...Voltage }],
  equation: "C=Q/V",
};
const capacitorEnergyMode: CalcMode = {
  id: "001capacitorenergy",
  name: "capacitor_energy",
  baseQuantities: [{ ...Energy }, { ...Capacitance }, { ...Voltage }],
  equation: "E=0.5*C*V\u00B2",
};
const batteryCapacityMode: CalcMode = {
  id: "001batterycapacity",
  name: "battery_capacity",
  baseQuantities: [{ ...Energy }, { ...Voltage }, { ...ElectricCharge }],
  equation: "E=V*q",
};

export const capcitorCalc: Calculator = {
  type: AppData.CALCULATOR,
  updatedAt: "2022-11-13",
  name: "capacitor",
  branch: "Electric",
  difficulty: "simple",
  inputs: [capacitanceMode, capacitorEnergyMode, batteryCapacityMode],
  calculate: [
    {
      name: "capacitance",
      equations: [
        {
          target: "capacitance",
          expression: "(electric_charge) / (voltage)",
        },
        {
          target: "electric_charge",
          expression: "(capacitance) * (voltage)",
        },
        {
          target: "voltage",
          expression: "(electric_charge) / (capacitance)",
        },
      ],
    },
    {
      name: "capacitor_energy",
      equations: [
        {
          target: "energy",
          expression: "0.5 * (capacitance) * (voltage)^2",
        },
        {
          target: "capacitance",
          expression: "(energy) / (0.5 * (voltage)^2)",
        },
        {
          target: "voltage",
          expression: "((energy) / (0.5 * (capacitance)))^0.5",
        },
      ],
    },
    {
      name: "battery_capacity",
      equations: [
        {
          target: "energy",
          expression: "(voltage) * (electric_charge)",
        },
        {
          target: "voltage",
          expression: "(energy) / (electric_charge)",
        },
        {
          target: "electric_charge",
          expression: "(energy) / (voltage)",
        },
      ],
    },
  ],
};
